import { Sparkles, Search } from "lucide-react";
import { HeroCanvas } from "./HeroCanvas";

export const SphereVisual = ({ caption }) => (
  <div className="absolute inset-0 bg-[#100a26]">
    <div className="grid-lines absolute inset-0 opacity-70" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_45%,rgba(139,92,246,0.35),transparent_60%)]" />
    <HeroCanvas />
    {caption && <p className="absolute bottom-6 left-6 right-6 font-mono text-[11px] uppercase tracking-[0.22em] text-violet-200">{caption}</p>}
  </div>
);

export const AnswerVisual = () => (
  <div className="absolute inset-0 flex flex-col justify-center gap-4 bg-[#100a26] p-6 sm:p-8">
    <div className="grid-lines absolute inset-0 opacity-60" />
    <div className="relative flex items-center gap-3 rounded-full border border-white/15 bg-white/10 px-4 py-3 backdrop-blur-md">
      <Search className="h-4 w-4 text-violet-200" />
      <span className="text-sm text-white">What should I look for in a provider?</span>
    </div>
    <div className="relative rounded-3xl border border-violet-400/30 bg-[#1a1038]/90 p-5 backdrop-blur-md">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-violet-300"><Sparkles className="h-3.5 w-3.5" /> Answer</p>
      <div className="mt-4 space-y-2.5">
        {[92, 78, 85, 60].map((w, i) => <div key={i} className="h-2 rounded-full bg-white/15" style={{ width: `${w}%` }} />)}
      </div>
      <div className="mt-5 flex flex-wrap gap-2">
        {["Clear headings", "Direct answers", "Evidence"].map((s) => (
          <span key={s} className="rounded-full border border-violet-300/40 bg-violet-500/15 px-3 py-1 text-[12px] text-violet-100">{s}</span>
        ))}
      </div>
    </div>
    <p className="relative font-mono text-[11px] uppercase tracking-[0.22em] text-violet-200">Question · Structure · Evidence · Authority</p>
  </div>
);
